<template>
  <div class="accidentRescueDetail">
    <van-pull-refresh
      v-model="isLoading"
      @refresh="onRefresh"
    >
      <van-tabs
        v-model="active"
        color="#3399FF"
        @change="changeActive"
      >
        <van-tab
          title="案件信息"
          name="1"
        ><case-info :form-data="formData" /></van-tab>
        <van-tab
          title="日志信息"
          name="2"
        >
          <log :order-route="orderRoute" />
        </van-tab>
        <van-tab
          title="照片"
          name="3"
        >
          <photo :media-info-list="mediaInfoList" />
        </van-tab>
      </van-tabs>
    </van-pull-refresh>
  </div>
</template>
<script>
import caseInfo from './components/caseInfo.vue';
import log from './components/log.vue';
import photo from './components/photo.vue';
import { getOrderDetail, getOrderRoute, orderMediaInfo } from '@/common/api.js';
export default {
  data() {
    return {
      active: '1',
      formData: {},
      orderRoute: {},
      mediaInfoList: [],
      isLoading: false
    };
  },
  components: {
    caseInfo,
    log,
    photo
  },
  mounted() {
    this.getOrderDetail();
    this.getOrderRoute();
    this.orderMediaInfo();
  },
  methods: {
    async onRefresh() {
      this.isLoading = true;
      await this.getOrderDetail();
      await this.getOrderRoute();
      await this.orderMediaInfo();
      this.isLoading = false;
    },
    async getOrderDetail() {
      try {
        const res = await getOrderDetail({ orderNo: this.$route.query.orderNo });
        if (res) {
          // console.log(res, '--');
          this.formData = res;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getOrderRoute() {
      try {
        const res = await getOrderRoute({ orderNo: this.$route.query.orderNo });
        if (res) {
          this.orderRoute = res;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async orderMediaInfo() {
      try {
        const res = await orderMediaInfo({
          orderNo: this.$route.query.orderNo,
          templateType: 'mainTemplate',
          source: 4
        });
        if (res) {
          this.mediaInfoList = res.mediaInfoDTOList;
        }
      } catch (error) {
        console.log(error);
      }
    },
    changeActive() {}
  }
};
</script>
<style lang="scss" scoped>
.accidentRescueDetail{
  height: 100%;

  background: #F2F3F5;

  font-size: 0.32rem;
}
</style>
